import React, { useState, useEffect } from "react";
import "../../../Assets/UserDetails.css";
import { ReactComponent as VerifiedIcon } from "../../../Assets/images/icon/verifiedIcon.svg";
import { Avatar, Button, message, Spin } from "antd";
import {
  InstagramOutlined,
  GlobalOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";
import { Input, Row, Col } from "antd";
import DeleteUserModal from "./DeleteUserModal";
import DeactiveUserModal from "./DeactiveUserModal";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { fetchUserData, deleteUser } from "../useAPIDetails/useFetchUserList";
import MakeAdminModal from "./MakeAdminModal";
import UserCuisineModal from "./UserCuisineModal";
import UserDietaryPreferencesModal from "./UserDietaryPreferencesModal";
import { ReactComponent as ArrowBackIcon } from "../../../Assets/images/icon/ArrowBack Icon.svg";
import facebookIcon from "../../../Assets/images/icon/facebook-icon.png";
import instagramIcon from "../../../Assets/images/icon/instgram-icon.png";
import tiktokIcon from "../../../Assets/images/icon/tiktok-icon.png";
import BrowserIcon from "../../../Assets/images/icon/browserIcon.png"

const LinkInput = ({ icon, value }) => {
  return (
    <Input
      prefix={
        typeof icon === "string" ? (
          <img
            src={icon}
            alt="icon"
            style={{ width: "20px", height: "20px", marginRight: "10px" }}
          />
        ) : (
          icon // This allows Ant Design icons like <GlobalOutlined />
        )
      }
      value={value || "N/A"}
      readOnly
      style={{
        borderColor: "#9E9E9E",
        borderWidth: "1px",
        borderRadius: "8px",
        height: "48px",
        fontSize: "16px",
        display: "flex",
        alignItems: "center",
      }}
    />
  );
};

const UserDetailedView = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalDeactivate, setIsModalDeactive] = useState(false);
  const [isModalMakeAdmin, setIsModalMakeAdmin] = useState(false);
  const [ModalOpenDietaryPreference, setDietaryPreference] = useState(false);
  const [ModalOpenCuisines, setModalCusines] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const data = await fetchUserData(id);
        setUserData(data);
      } catch (error) {
        console.error(
          error?.response?.data?.message || "Failed to load user data"
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadUserData();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );
  }

  if (!userData) {
    return <div>Error loading user data</div>;
  }

  const confirmDelete = async () => {
    setIsModalVisible(false);
    try {
      await deleteUser(id);
      message.success("User deleted successfully.");
      navigate("/user-details");
      //onSuccess(); // Refresh user list or perform necessary action
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Failed to delete user. Please try again."
      );
    }
  };

  const convertAgeGroup = (ageGroup) => {
    const match = ageGroup.match(/\d+/g);
    if (!match || match.length < 2) return ageGroup;

    const lower = parseInt(match[0], 10) - 1;
    const upper = parseInt(match[1], 10) + 1;

    return `${lower} to ${upper}`;
  };

  if (!userData?.id) {
    return "user id not found";
  }

  return (
    <>
      <div className="user-detailed-container">
        <div className="header-user-detail sticky-header">
          <div
            className="arrow-icon-left pointer"
            onClick={() => navigate("/user-details")}
          >
            <ArrowBackIcon />
          </div>
          <div className="header-texthead">User Detail</div>
        </div>

        <Row style={{ backgroundColor: "#FAFAFA" }}>
          {/* User Profile Section */}
          <Col span={9} style={{ padding: "35px" }}>
            <div className="flex-center-column" style={{ gap: "15px" }}>
              <Avatar
                src={
                  userData.profilePicture?.fileUrl ||
                  "https://via.placeholder.com/206"
                }
                size={206}
                style={{ border: "2px solid #e6e6e6" }}
              />
              <div className="flex-center-column">
                <div className="flex-center">
                  <div className="user-detail-text">{`${userData.firstName} ${userData.lastName}`}</div>
                  {userData.verified && (
                    <div className="verified-icon-size27px">
                      <VerifiedIcon />
                    </div>
                  )}
                </div>
                <div
                  className="user-detail-text text-bold"
                  style={{ fontSize: "18px" }}
                >
                  {userData.userName}
                </div>
                <div
                  className="user-detail-text text-bold"
                  style={{ fontSize: "18px" }}
                >
                  {userData?.email}
                </div>
                <div
                  className="user-detail-text text-bold"
                  style={{ fontSize: "18px" }}
                >
                  {userData?.phoneNumber}
                </div>
              </div>

              <div className="recipes-detail-box flex-center-evenly">
                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData.additionalInfo?.postsCount || 0}
                  </div>
                  <div className="font-size-18px">Recipes</div>
                </div>
                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData.additionalInfo?.postsCount || 0}
                  </div>
                  <div className="font-size-18px">Posts</div>
                </div>
              </div>

              <Button
                className="primary-button"
                onClick={() => setIsModalMakeAdmin(true)}
              >
                Make Admin
              </Button>
              <Button
                className="primary-button"
                onClick={() => setIsModalVisible(true)}
              >
                Delete User
              </Button>
              <Button
                className="primary-button"
                onClick={() => setIsModalDeactive(true)}
              >
                DeActivate User
              </Button>
            </div>
          </Col>

          {/* User Details Section */}
          <Col span={15} style={{ padding: "35px" }}>
            <div
              className="flex-center-column"
              style={{ gap: "40px", alignItems: "unset" }}
            >
              <div className="user-details-bigBox flex-center-evenly">
                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData?.additionalInfo?.likesCount || 0}
                  </div>
                  <div className="font-size-18px">Likes</div>
                </div>
                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData?.additionalInfo?.savedCount || 0}
                  </div>
                  <div className="font-size-19px">Saves</div>
                </div>

                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData?.additionalInfo?.followersCount}
                  </div>
                  <div className="font-size-18px">Followers</div>
                </div>
                <div className="flex-center-column">
                  <div className="text-bold font-size-18px">
                    {userData?.additionalInfo?.followeeCount}
                  </div>
                  <div className="font-size-18px">Following</div>
                </div>
              </div>

              <div
                style={{
                  textAlign: "left",
                }}
              >
                <div
                  className="sub-heading-user text-bold"
                  style={{ padding: 0 }}
                >
                  Age Group:
                  <div
                    className="user-detail-text"
                    style={{
                      fontSize: "14px",
                      marginLeft: "10px",
                      display: "inline",
                    }}
                  >
                    {convertAgeGroup(userData?.ageGroup)}
                  </div>
                </div>
              </div>

              {/* Bio Section */}
              <div
                className="flex-center-column"
                style={{ gap: "20px", alignItems: "unset" }}
              >
                <div
                  className="sub-heading-user text-bold"
                  style={{ padding: 0 }}
                >
                  Bio:
                </div>
                <div
                  className="user-detail-text"
                  style={{ padding: 0, lineHeight: "25px" }}
                >
                  {userData?.bio || "No bio available"}{" "}
                </div>
              </div>

              {/* Links Section */}
              <div
                className="flex-center-column"
                style={{ gap: "20px", alignItems: "unset" }}
              >
                <div
                  className="sub-heading-user text-bold"
                  style={{ padding: 0 }}
                >
                  Links:
                </div>
                <Row gutter={16}>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <LinkInput
                      icon={<img
                        src={BrowserIcon}
                        alt="icon"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "10px",
                        }}
                      />}
                      value={userData?.additionalInfo?.customLink}
                    />
                  </Col>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <LinkInput
                      icon={
                        <img
                          src={facebookIcon}
                          alt="icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                      }
                      value={userData?.additionalInfo?.facebookLink}
                    />
                  </Col>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <LinkInput
                      icon={
                        <img
                          src={instagramIcon}
                          alt="icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                      }
                      value={userData.additionalInfo?.instagramLink}
                    />
                  </Col>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <LinkInput
                      icon={
                        <img
                          src={tiktokIcon}
                          alt="icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                      }
                      value={userData?.additionalInfo?.tiktokLink}
                    />
                  </Col>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <Button
                      className="primary-button"
                      style={{ width: "100%" }}
                      onClick={() => {
                        setDietaryPreference(true);
                      }}
                    >
                      Show Dietery Preferences
                    </Button>
                  </Col>
                  <Col span={12} style={{ padding: "10px", paddingRight: 15 }}>
                    <Button
                      className="primary-button"
                      style={{ width: "100%" }}
                      onClick={() => {
                        setModalCusines(true);
                      }}
                    >
                      Show cuisines
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        {/* Modals */}
        <MakeAdminModal
          isModalVisible={isModalMakeAdmin}
          setIsModalVisible={setIsModalMakeAdmin}
        />
        <DeleteUserModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          onConfirm={confirmDelete}
          userId={id}
          userName={`${userData?.firstName} ${userData?.lastName}`}
        />
        <DeactiveUserModal
          isModalVisible={isModalDeactivate}
          setIsModalVisible={setIsModalDeactive}
          userName={`${userData?.firstName} ${userData?.lastName}`}
        />

        <UserDietaryPreferencesModal
          userId={id}
          isOpen={ModalOpenDietaryPreference}
          onClose={() => {
            setDietaryPreference(false);
          }}
        />

        <UserCuisineModal
          userId={id}
          isOpen={ModalOpenCuisines}
          onClose={() => {
            setModalCusines(false);
          }}
        />
      </div>
    </>
  );
};

export default UserDetailedView;
